import { Label, Shimmer, Stack } from "@fluentui/react";
import React, { FunctionComponent } from "react";

import { Text } from "../Text";

export interface ShimmeredLabeledTextProps {
    isLoading: boolean;
    label: string;
    shimmerWidth?: number | string;
    textColor?: string;
    value?: string | number;
}

export const ShimmeredLabeledText: FunctionComponent<ShimmeredLabeledTextProps> = (
    props: ShimmeredLabeledTextProps
) => {
    const { isLoading, label, shimmerWidth, textColor, value } = props;
    const width = shimmerWidth ?? "100%";

    return (
        <Stack styles={{ root: { marginBottom: 10 } }}>
            <Label>{label}</Label>
            <Text styles={{ root: { color: textColor } }}>
                {isLoading ? (
                    <Shimmer style={{ width, maxWidth: "100%", height: "18.66px", position: "relative", top: "3px" }} />
                ) : (
                    value
                )}
            </Text>
        </Stack>
    );
};
